import qs from "qs";
import { request } from "../http/http";

export default class EntityService {
  request = request;

  constructor(name) {
    this.name = name;
    this.request = request;
  }

  /**
   * 获取Entity分页
   * @param {*} entities
   * @param {*} pageable
   * @returns
   */
  async getEntityPage(entities, pageable) {
    const sortStr = qs.stringify(pageable, { arrayFormat: "repeat" });

    const result = await request({
      url: `/${this.name}s?${sortStr}`,
      method: "get",
      params: {
        ...entities
        // ...pageable
      }
    });

    return result;
  }

  /**
   *批量添加Entity
   * @param {*} entities
   * @param {*} pageable
   * @returns
   */
  async addEntities(entities) {
    const result = await request({
      url: `/${this.name}s`,
      method: "post",
      data: entities
    });
    return result;
  }

  /**
   *批量更新Entity
   * @param {*} entities
   * @param {*} pageable
   * @returns
   */
  async updateEntities(entities) {
    const result = await request({
      url: `/${this.name}s`,
      method: "patch",
      data: entities
    });
    return result;
  }

  /**
   *批量删除Entity
   * @param {*} entities
   * @param {*} pageable
   * @returns
   */
  async deleteEntities(entities) {
    const result = await request({
      url: `/${this.name}s`,
      method: "delete",
      data: entities
    });
    return result;
  }

  /**
   * 获取Entity导出文件
   * @returns
   */
  async getEntityFile() {
    const result = await request({
      url: `/${this.name}s/file`,
      method: "get",
      responseType: "blob"
    });

    return result;
  }

  /**
   * 获取全部Entity
   * @param {*} entity
   * @param {*} sort
   * @returns
   */
  async countEntities(entity) {
    const result = await request({
      url: `/${this.name}`,
      method: "options",
      params: {
        ...entity
      }
    });

    return result;
  }

  /**
   * 获取全部Entity
   * @param {*} entity
   * @param {*} sort
   * @returns
   */
  async getEntities(entity, sort) {
    const sortStr = qs.stringify(sort, { arrayFormat: "repeat" });

    const result = await request({
      url: `/${this.name}?${sortStr}`,
      method: "get",
      params: {
        ...entity
        // ...sort,
      }
    });

    return result;
  }

  async getRelateProducts(exhibitorId, params) {
    const result = await request({
      url: `/web/exhibitPage?exhibitorId=${exhibitorId}`,
      method: "get",
      params
    });

    return result;
  }

  /**
   * 根据id获取entity
   * @param {*} entity
   * @param {*} pageable
   * @returns
   */
  async getEntityDetail(entity) {
    if (!entity.id) {
      throw new Error("参数必须包含id");
    }

    const result = await request({
      url: `/web/${this.name}/${entity.id}`,
      method: "get"
    });

    return result;
  }

  /**
   * 根据id获取entity
   * @param {*} entity
   * @param {*} pageable
   * @returns
   */
  async getEntity(entity) {
    if (!entity.id) {
      throw new Error("参数必须包含id");
    }

    const result = await request({
      url: `/${this.name}/${entity.id}`,
      method: "get"
    });

    return result;
  }

  /**
   * 添加Entity
   * @param {*} entity
   * @param {*} pageable
   * @returns
   */
  async addEntity(entity) {
    const result = await request({
      url: `/${this.name}`,
      method: "post",
      data: entity
    });

    return result;
  }

  /**
   * 更新Entity
   * @param {*} entity
   * @param {*} pageable
   * @returns
   */
  async updateEntity(entity) {
    if (!entity.id) {
      throw new Error("参数必须包含id");
    }

    const result = await request({
      url: `/${this.name}/${entity.id}`,
      method: "patch",
      data: entity
    });

    return result;
  }

  /**
   * 删除Entity
   * @param {*} entity
   * @param {*} pageable
   * @returns
   */
  async deleteEntity(entity) {
    if (!entity.id) {
      throw new Error("参数必须包含id");
    }

    const result = await request({
      url: `/${this.name}/${entity.id}`,
      method: "delete"
    });

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/services/entity.js